var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navBar", attrs: { id: "test" } }, [
    _c("div", { staticClass: "header top" }, [
      _c("div", { staticClass: "con-wrap" }, [
        _vm._m(0),
        _c("div", { staticClass: "jumpTitle" }, [
          _c(
            "p",
            {
              on: {
                click: function($event) {
                  return _vm.jumpLink("3")
                }
              }
            },
            [_vm._v("账号自助管理")]
          ),
          _c(
            "p",
            {
              on: {
                click: function($event) {
                  return _vm.jumpLink("2")
                }
              }
            },
            [_vm._v("账号中心")]
          )
        ]),
        _c("div", { staticClass: "op-wrap" }, [
          _c(
            "a",
            {
              staticClass: "btn-menu",
              attrs: { id: "menu_btn", href: "javascript:;", role: "button" },
              on: { click: _vm.menu }
            },
            [
              _c("i", { staticClass: "line" }),
              _c("i", { staticClass: "line" }),
              _c("i", { staticClass: "line" })
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "menu-wrap", attrs: { id: "menu_modal" } }, [
        _vm.isHomeBar
          ? _c("ul", { staticClass: "list" }, [
              _vm._m(1),
              _c("li", { staticClass: "item" }, [
                _c(
                  "a",
                  {
                    staticClass: "txt",
                    on: {
                      click: function($event) {
                        return _vm.jumpLink("1")
                      }
                    }
                  },
                  [_c("span", [_vm._v("账号注册")])]
                )
              ]),
              _c("li", { staticClass: "item" }, [
                _c(
                  "a",
                  {
                    staticClass: "txt",
                    on: {
                      click: function($event) {
                        return _vm.jumpLink("2")
                      }
                    }
                  },
                  [_c("span", [_vm._v("账号中心")])]
                )
              ]),
              _c("li", { staticClass: "item" }, [
                _c(
                  "a",
                  {
                    staticClass: "txt",
                    on: {
                      click: function($event) {
                        return _vm.jumpLink("3")
                      }
                    }
                  },
                  [_c("span", [_vm._v("账号自助管理")])]
                )
              ])
            ])
          : _vm._e(),
        _c("ul", { staticClass: "list" }, [
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("accountInfo")
                  }
                }
              },
              [_c("span", [_vm._v("账号信息")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("editPhoneNum")
                  }
                }
              },
              [_c("span", [_vm._v("修改密码")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("identityAuth")
                  }
                }
              },
              [_c("span", [_vm._v("身份认证")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("phoneManage")
                  }
                }
              },
              [_c("span", [_vm._v("手机号管理")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("logoutAccount")
                  }
                }
              },
              [_c("span", [_vm._v("账号/单手游注销")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.jumpPage("accountSecurity")
                  }
                }
              },
              [_c("span", [_vm._v("账号安全")])]
            )
          ]),
          _c("li", { staticClass: "item" }, [
            _c(
              "a",
              {
                staticClass: "txt",
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [_c("span", [_vm._v("退出")])]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "logo",
        attrs: { href: "//www.leiting.com/mobile/index.html" }
      },
      [
        _vm._v("雷霆游戏 "),
        _c("img", {
          attrs: {
            src: "//static.leiting.com/images/common/lt_logo_dark.png",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "item" }, [
      _c(
        "a",
        {
          staticClass: "txt",
          attrs: { href: "//www.leiting.com/mobile/index.html" }
        },
        [_c("span", [_vm._v("首页")])]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }